import type { ClaimWorkItem } from '../../../store';
import { formatDateOnly } from '../../../utils';

export type ClaimWorkPayerStatus = NonNullable<ClaimWorkItem['last_payer_status']>;

/**
 * "Accepted Jul 29 · A1:19": the last thing the payer side said, the kind
 * first, then when, then the code. Home's Awaiting payer cell and the Reason
 * popover both say it, so it is said once.
 */
export const formatPayerStatusLine = (status: ClaimWorkPayerStatus | null | undefined): string => {
  if (!status) return '';
  const kind = status.kind.charAt(0).toUpperCase() + status.kind.slice(1);
  const when = formatDateOnly(status.occurred_at, { day: 'numeric', month: 'short' }, '');
  return [when ? `${kind} ${when}` : kind, status.code].filter(Boolean).join(' · ');
};
